<template>
  <div>
    <div
      class="botter-agent-chat-image"
      v-if="sender && sender.sender_type === 'USER'"
    >
      <img
        src="https://gamma-api.botter.live/uploads/2020-08-16/1597590733.png"
        alt=""
      />
    </div>
    <div class="botter-bot-chat-image" v-else>
      <img
        :src="
          sender.avatar || 'https://portal.botter.live/img/logo.8878de79.png'
        "
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "chatImage",
  props: {
    sender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.botter-bot-chat-image {
  background: var(--primaryColor);
  position: absolute;
  bottom: 0;
  left: 5px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 25px;
    height: 25px;
    filter: brightness(0) invert(1);
  }
}

.botter-agent-chat-image {
  float: right;

  border-radius: 100%;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 36px;
    height: 36px;
  }
}

.botter-hero {
  .botter-bot-chat-image,
  .botter-agent-chat-image {
    bottom: 0px;
  }
}

.botter-typing-card,
.botter-agent-chat-image {
  .botter-bot-chat-image {
    bottom: 0px;
  }
}
.botter-trivia {
  .botter-bot-chat-image,
  .botter-agent-chat-image {
    bottom: 60px;
  }
}
</style>
